export class USDC {
  value: bigint;
  pretty: string;

  constructor(value: bigint) {
    this.value = BigInt(value);
    const usdcFloat = Number(this.value) / Number(10 ** 6);
    this.pretty = Intl.NumberFormat(undefined, {
      maximumFractionDigits: 4,
    }).format(usdcFloat);
  }

  static empty(): USDC {
    return new USDC(0n);
  }

  toString(): string {
    return `USDC(value: ${this.value}, pretty: ${this.pretty})`;
  }

  add(other?: USDC): USDC {
    return new USDC(this.value + (other?.value ?? 0n));
  }

  sub(other: USDC) {
    return new USDC(this.value - (other?.value ?? 0n));
  }

  static zero(): USDC {
    return new USDC(0n);
  }
}
